import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function ContentHub() {
  const recentArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            探索磁力金牛知识库
          </h2>
          <p className="text-foreground-500">从入门到精通，全方位掌握财富增长之道</p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-2 px-4 py-2 rounded-full border border-background-300/60 bg-background-50 hover:border-primary-300 hover:bg-primary-50 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-all whitespace-nowrap"
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {recentArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              {(() => {
                const cat = categories.find((c) => c.slug === article.category);
                const catColor = cat?.color === 'accent'
                  ? 'bg-accent-100 text-accent-800'
                  : 'bg-primary-100 text-primary-800';
                return (
                  <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium ${catColor} mb-3`}>
                    {cat?.name}
                  </span>
                );
              })()}
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span>{article.date}</span>
                <span>{article.readTime}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/tutorial"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            浏览全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}